import { render, staticRenderFns } from "./ModalAgeRating.vue?vue&type=template&id=3205318c"
import script from "./ModalAgeRating.vue?vue&type=script&lang=js"
export * from "./ModalAgeRating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports